const StickyFormActions = {
    frame: null,
    observer: null,

    init() {
        document.addEventListener("scroll", () => this.scheduleUpdate(), true);
        window.addEventListener("resize", () => this.scheduleUpdate());
        $(document).on("shown.bs.modal pjax:end ajaxComplete", () => this.scheduleUpdate());

        this.observer = new MutationObserver(() => this.scheduleUpdate());
        this.observer.observe(document.body, { childList: true, subtree: true });
        this.update();
    },

    scheduleUpdate() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            this.update();
        });
    },

    update() {
        const isMobile = window.matchMedia("(max-width: 575px)").matches;

        $(".app-form__actions").each(function () {
            const actions = $(this);
            let marker = actions.prev(".app-form__actions-marker");

            if (!marker.length) {
                marker = $('<span class="app-form__actions-marker" aria-hidden="true"></span>');
                actions.before(marker);
            }

            if (!isMobile || !actions.is(":visible")) {
                actions.removeClass("is-floating");
                return;
            }

            const scrollContainer = actions.closest(".modal-content").get(0);
            const containerBottom = scrollContainer
                ? Math.min(scrollContainer.getBoundingClientRect().bottom, window.innerHeight)
                : window.innerHeight;
            const naturalActionsBottom = marker.get(0).getBoundingClientRect().top + actions.outerHeight();
            const isFloating = naturalActionsBottom > containerBottom + 1;

            actions.toggleClass("is-floating", isFloating);
        });
    },
};

export default StickyFormActions;
